module.exports = __webpack_public_path__ + "static/img/footer_log.1d83d47.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/footer_log.png
// module id = oxzh
// module chunks = 23